import GalleryItemModel from './GalleryItemModel';

const GalleryElementModel = {
  elements: [],
};

export default GalleryElementModel;
